// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-63e563db","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./FrontEnd/modulos/central-mensagens/componentes/Sessao.vue
// module id = 1225
// module chunks = 0